import { ICommunicationHistory } from '@dataTypes/communicationHistory.type'
import { default as axios } from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

export interface GetCommunicationHistoryResponse {
  statusCode: number
  message: string
  data: {
    logs: ICommunicationHistory[]
  }
}

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PATIENT')
const headers = {
  'Content-Type': 'application/json',
}

export const getCommunicationHistory = async (
  patientId: string,
): Promise<GetCommunicationHistoryResponse> => {
  try {
    const response = await axios.get<GetCommunicationHistoryResponse>(
      `${BUSINESS_LAYER_API}/api/v1/patient/${patientId}/communication-history`,
      {
        headers,
      },
    )

    return response.data
  } catch (error: any) {
    logger.error('Error in getCommunicationHistory:', error)
    throw toApiError(error, 'Error fetching communication history')
  }
}
